var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrganisation = function SvgOrganisation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110373)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110373)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10345_110373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8124 53.5104L69.1686 47.5312L58.8124 53.5104ZM58.8124 53.5104L69.2318 47.4948L69.2318 61.7135L58.8124 67.7291L58.8124 53.5104ZM69.1686 61.677L58.8124 67.6562L69.1686 61.677ZM69.1686 47.5312L58.8124 53.5104L59.6965 50.8125L68.2846 45.8541L69.1686 47.5312ZM56.918 68.75L71.063 60.5833Z",
    fill: "url(#paint2_linear_10345_110373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.918 68.75L71.063 60.5833M58.8124 53.5104L69.1686 47.5312L58.8124 53.5104ZM58.8124 53.5104L69.2318 47.4948L69.2318 61.7135L58.8124 67.7291L58.8124 53.5104ZM69.1686 61.677L58.8124 67.6562L69.1686 61.677ZM69.1686 47.5312L58.8124 53.5104L59.6965 50.8125L68.2846 45.8541L69.1686 47.5312Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1491 54.5677C61.0228 54.6406 60.8965 54.6406 60.8965 54.4948M65.38 62.2604C65.38 61.3854 64.7485 61.0208 63.9907 61.4583C63.2329 61.8958 62.6015 62.9896 62.6015 63.8646L62.6015 65.4688L65.4431 63.8281L65.4431 62.224L65.38 62.2604ZM61.1491 54.0573C61.2754 53.9844 61.4017 54.0573 61.4017 54.2031L61.1491 54.0573ZM60.8965 54.4948C60.8965 54.349 61.0228 54.1302 61.1491 54.0573L60.8965 54.4948Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1491 57.8489C61.0228 57.9218 60.8965 57.8489 60.8965 57.7031M61.4017 54.2031C61.4017 54.3489 61.2754 54.5677 61.1491 54.6406L61.4017 54.2031ZM61.1491 57.3385C61.2754 57.2656 61.4017 57.3385 61.4017 57.4843L61.1491 57.3385ZM60.8965 57.7031C60.8965 57.5573 61.0228 57.3385 61.1491 57.2656L60.8965 57.7031Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8965 61.0573C60.8965 60.9115 61.0228 60.6927 61.1491 60.6198M61.4017 57.4115C61.4017 57.5573 61.2754 57.776 61.1491 57.849L61.4017 57.4115ZM61.1491 60.6198C61.2754 60.5469 61.4017 60.6198 61.4017 60.7656L61.1491 60.6198Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7381 52.8542C63.7381 52.7083 63.8644 52.4896 63.9907 52.4167M61.1491 61.1302C61.0228 61.2031 60.8965 61.1302 60.8965 60.9844L61.1491 61.1302ZM61.4017 60.7656C61.4017 60.9115 61.2754 61.1302 61.1491 61.2031L61.4017 60.7656ZM63.9907 52.4167C64.117 52.3438 64.2433 52.4167 64.2433 52.5625L63.9907 52.4167Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9904 56.2083C63.8641 56.2813 63.7378 56.2083 63.7378 56.0625M63.9904 52.9271C63.8641 53 63.7378 52.9271 63.7378 52.7812L63.9904 52.9271ZM64.243 52.5625C64.243 52.7083 64.1167 52.9271 63.9904 53L64.243 52.5625ZM63.9904 55.6979C64.1167 55.625 64.243 55.6979 64.243 55.8438L63.9904 55.6979ZM63.7378 56.0625C63.7378 55.9167 63.8641 55.6979 63.9904 55.625L63.7378 56.0625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7378 59.4167C63.7378 59.2708 63.8641 59.0521 63.9904 58.9792M64.243 55.7708C64.243 55.9167 64.1167 56.1354 63.9904 56.2083L64.243 55.7708ZM63.9904 58.9792C64.1167 58.9062 64.243 58.9792 64.243 59.125L63.9904 58.9792Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5794 51.2135C66.5794 51.0677 66.7057 50.849 66.832 50.776M63.9904 59.4896C63.8641 59.5625 63.7378 59.4896 63.7378 59.3438L63.9904 59.4896ZM64.243 59.125C64.243 59.2708 64.1167 59.4896 63.9904 59.5625L64.243 59.125ZM66.832 50.776C66.9583 50.7031 67.0846 50.776 67.0846 50.9219L66.832 50.776Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8322 54.5677C66.7059 54.6406 66.5796 54.5677 66.5796 54.4219M66.8322 51.2865C66.7059 51.3594 66.5796 51.2865 66.5796 51.1406L66.8322 51.2865ZM67.0848 50.9219C67.0848 51.0677 66.9585 51.2865 66.8322 51.3594L67.0848 50.9219ZM66.8322 54.0573C66.9585 53.9844 67.0848 54.0573 67.0848 54.2031L66.8322 54.0573ZM66.5796 54.4219C66.5796 54.276 66.7059 54.0573 66.8322 53.9844L66.5796 54.4219Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5796 57.776C66.5796 57.6302 66.7059 57.4115 66.8322 57.3385M67.0848 54.1302C67.0848 54.276 66.9585 54.4948 66.8322 54.5677L67.0848 54.1302ZM66.8322 57.3385C66.9585 57.2656 67.0848 57.3385 67.0848 57.4844L66.8322 57.3385Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0848 57.4844C67.0848 57.6302 66.9585 57.849 66.8322 57.9219M66.8322 57.849C66.7059 57.9219 66.5796 57.849 66.5796 57.7031L66.8322 57.849Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint3_linear_10345_110373)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110373",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110373",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110373",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA3C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110373",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF79A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110373",
    x1: 71.063,
    y1: 60.6517,
    x2: 56.5095,
    y2: 53.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110373",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF70A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10345_110373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 56.4126 52.125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrganisation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "organisation.b747db074ce9925ddfbd5c4e6762cab0.svg";